/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { unproxiedMcpCreateServer } from "../funcs/unproxiedMcpCreateServer.js";
import { unproxiedMcpDeleteServer } from "../funcs/unproxiedMcpDeleteServer.js";
import { unproxiedMcpGetServer } from "../funcs/unproxiedMcpGetServer.js";
import { unproxiedMcpListServers } from "../funcs/unproxiedMcpListServers.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListUnproxiedMcpServersResult } from "../models/components/listunproxiedmcpserversresult.js";
import { UnproxiedMcpServer } from "../models/components/unproxiedmcpserver.js";
import {
  CreateUnproxiedMcpServerRequest,
  CreateUnproxiedMcpServerSecurity,
} from "../models/operations/createunproxiedmcpserver.js";
import {
  DeleteUnproxiedMcpServerRequest,
  DeleteUnproxiedMcpServerSecurity,
} from "../models/operations/deleteunproxiedmcpserver.js";
import {
  GetUnproxiedMcpServerRequest,
  GetUnproxiedMcpServerSecurity,
} from "../models/operations/getunproxiedmcpserver.js";
import {
  ListUnproxiedMcpServersRequest,
  ListUnproxiedMcpServersSecurity,
} from "../models/operations/listunproxiedmcpservers.js";
import { unwrapAsync } from "../types/fp.js";

export class UnproxiedMcp extends ClientSDK {
  /**
   * createServer unproxiedMcp
   *
   * @remarks
   * Create a new unproxied MCP server. Restricted to callers whose email is on the speakeasy.com or speakeasyapi.dev domain.
   */
  async createServer(
    request: CreateUnproxiedMcpServerRequest,
    security?: CreateUnproxiedMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UnproxiedMcpServer> {
    return unwrapAsync(unproxiedMcpCreateServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteServer unproxiedMcp
   *
   * @remarks
   * Delete an unproxied MCP server
   */
  async deleteServer(
    request: DeleteUnproxiedMcpServerRequest,
    security?: DeleteUnproxiedMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(unproxiedMcpDeleteServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getServer unproxiedMcp
   *
   * @remarks
   * Get an unproxied MCP server by ID or slug. Exactly one of id or slug must be provided.
   */
  async getServer(
    request?: GetUnproxiedMcpServerRequest | undefined,
    security?: GetUnproxiedMcpServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UnproxiedMcpServer> {
    return unwrapAsync(unproxiedMcpGetServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listServers unproxiedMcp
   *
   * @remarks
   * List all unproxied MCP servers for a project
   */
  async listServers(
    request?: ListUnproxiedMcpServersRequest | undefined,
    security?: ListUnproxiedMcpServersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListUnproxiedMcpServersResult> {
    return unwrapAsync(unproxiedMcpListServers(
      this,
      request,
      security,
      options,
    ));
  }
}
